import { CUSTOM_APP_ICON_PREFIX } from './myAppsApi';

export function isDxIconClass(icon: string): boolean {
  const value = icon.trim();
  return value.startsWith('dx-icon-') || value.split(/\s+/).includes('dx-icon');
}

export function isImageIcon(icon: string): boolean {
  const value = icon.trim();
  if (value.startsWith('data:image/')) return true;
  if (value.startsWith(CUSTOM_APP_ICON_PREFIX)) return true;
  // Admin pages serve uploaded icons from an authenticated same-origin route.
  // These URLs have no file extension, so they cannot be detected by suffix.
  if (value.startsWith('/api/') && value.includes('/custom-apps/') && value.includes('/icons/')) {
    return true;
  }
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}

export function MyAppsIcon({ icon, className }: { icon: string; className?: string }) {
  const value = icon.trim();
  if (isImageIcon(value)) {
    return (
      <img
        className={['my-apps-icon-image', className].filter(Boolean).join(' ')}
        src={value}
        alt=""
      />
    );
  }
  if (isDxIconClass(value)) {
    const classes = value.split(/\s+/).includes('dx-icon')
      ? [value, className]
      : ['dx-icon', value, className];
    return <i className={classes.filter(Boolean).join(' ')} aria-hidden />;
  }
  return (
    <span className={['my-apps-icon-emoji', className].filter(Boolean).join(' ')} aria-hidden>
      {value}
    </span>
  );
}
